import React from "react";

interface HeadshotFABProps {
  url: String | string | File;
}

export const HeadshotFAB: React.FC<HeadshotFABProps> = ({
  url
}) => {
  console.log("url", url);
  if (!url) return null;

  return (
    <div className="w-14 h-14 rounded-full shadow-lg border-2 border-white overflow-hidden cursor-pointer hover:scale-105 transition-transform duration-200">
      <img
        src={url.toString()}
        alt="Profile Headshot"
        className="w-full h-full object-cover"
      />
    </div>
  );
};
